export default __webpack_public_path__ + "bec0536fa90ac219a34f86751b236c48.svg";